var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutPopUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 107,
    height: 96,
    viewBox: "0 0 107 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "check_circle_FILL1_wght400_GRAD0_opsz24",
    x: 12.139,
    y: 12.23,
    width: 82.459,
    height: 82.459,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffd1a3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "check_circle_FILL1_wght400_GRAD0_opsz24-2",
    x: 12.139,
    y: 12.23,
    width: 82.459,
    height: 82.459,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffd1a3",
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "check_circle_FILL1_wght400_GRAD0_opsz24-3",
    x: 16.5,
    y: 16.5,
    width: 73.567,
    height: 73.567,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19078",
    "data-name": "Group 19078",
    transform: "translate(-114 -27)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(214 86)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(205 95)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(199 108)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(203 70)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(209 60)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(126 60)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(128 68)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(137 45)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(162 33)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(189 45)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(136 111)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(180 117)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(147 35)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(136 57)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(172 30)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(198 49)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(126 89)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(131 102)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(159 117)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(171 121)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(118 81)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(177 40)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(217 108)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(198 27)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(116 43)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(114 110)",
    fill: "#f68b1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(135.139 45.23)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21.14, -18.23)",
    filter: "url(#check_circle_FILL1_wght400_GRAD0_opsz24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check_circle_FILL1_wght400_GRAD0_opsz24-4",
    "data-name": "check_circle_FILL1_wght400_GRAD0_opsz24",
    d: "M112.23-815.541a31.388,31.388,0,0,1-12.57-2.536,32.547,32.547,0,0,1-10.233-6.893A32.531,32.531,0,0,1,82.538-835.2,31.4,31.4,0,0,1,80-847.771a31.367,31.367,0,0,1,2.538-12.569,32.56,32.56,0,0,1,6.889-10.234,32.581,32.581,0,0,1,10.233-6.888A31.391,31.391,0,0,1,112.23-880a31.392,31.392,0,0,1,12.57,2.539,32.578,32.578,0,0,1,10.233,6.888,32.556,32.556,0,0,1,6.889,10.234,31.372,31.372,0,0,1,2.538,12.569,31.4,31.4,0,0,1-2.538,12.571,32.528,32.528,0,0,1-6.889,10.229,32.544,32.544,0,0,1-10.233,6.893A31.389,31.389,0,0,1,112.23-815.541Z",
    transform: "translate(-58.86 898.23)",
    fill: "#fdffef"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21.14, -18.23)",
    filter: "url(#check_circle_FILL1_wght400_GRAD0_opsz24-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check_circle_FILL1_wght400_GRAD0_opsz24-5",
    "data-name": "check_circle_FILL1_wght400_GRAD0_opsz24",
    d: "M112.23-815.541a31.388,31.388,0,0,1-12.57-2.536,32.547,32.547,0,0,1-10.233-6.893A32.531,32.531,0,0,1,82.538-835.2,31.4,31.4,0,0,1,80-847.771a31.367,31.367,0,0,1,2.538-12.569,32.56,32.56,0,0,1,6.889-10.234,32.581,32.581,0,0,1,10.233-6.888A31.391,31.391,0,0,1,112.23-880a31.392,31.392,0,0,1,12.57,2.539,32.578,32.578,0,0,1,10.233,6.888,32.556,32.556,0,0,1,6.889,10.234,31.372,31.372,0,0,1,2.538,12.569,31.4,31.4,0,0,1-2.538,12.571,32.528,32.528,0,0,1-6.889,10.229,32.544,32.544,0,0,1-10.233,6.893A31.389,31.389,0,0,1,112.23-815.541Z",
    transform: "translate(-58.86 898.23)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(6.817 6.446)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.96, -24.68)",
    filter: "url(#check_circle_FILL1_wght400_GRAD0_opsz24-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check_circle_FILL1_wght400_GRAD0_opsz24-6",
    "data-name": "check_circle_FILL1_wght400_GRAD0_opsz24",
    d: "M105.784-828.433a25.111,25.111,0,0,1-10.056-2.029,26.039,26.039,0,0,1-8.186-5.514,26.026,26.026,0,0,1-5.511-8.183A25.118,25.118,0,0,1,80-854.217a25.092,25.092,0,0,1,2.03-10.055,26.046,26.046,0,0,1,5.511-8.188,26.064,26.064,0,0,1,8.186-5.51A25.113,25.113,0,0,1,105.784-880a25.113,25.113,0,0,1,10.056,2.031,26.063,26.063,0,0,1,8.186,5.51,26.044,26.044,0,0,1,5.511,8.188,25.1,25.1,0,0,1,2.031,10.055,25.122,25.122,0,0,1-2.031,10.057,26.023,26.023,0,0,1-5.511,8.183,26.037,26.037,0,0,1-8.186,5.514A25.112,25.112,0,0,1,105.784-828.433Z",
    transform: "translate(-52.5 904.5)",
    fill: "#f68b1f",
    stroke: "#fff",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    id: "priority_high_FILL0_wght400_GRAD0_opsz24_1_",
    "data-name": "priority_high_FILL0_wght400_GRAD0_opsz24 (1)",
    d: "M402.349-818.854a2.262,2.262,0,0,1-1.659-.69A2.262,2.262,0,0,1,400-821.2a2.262,2.262,0,0,1,.69-1.659,2.262,2.262,0,0,1,1.659-.69,2.262,2.262,0,0,1,1.659.69,2.263,2.263,0,0,1,.69,1.659,2.262,2.262,0,0,1-.69,1.659A2.262,2.262,0,0,1,402.349-818.854Zm0-7.048a2.262,2.262,0,0,1-1.659-.69,2.262,2.262,0,0,1-.69-1.659v-9.4a2.263,2.263,0,0,1,.69-1.659,2.262,2.262,0,0,1,1.659-.69,2.262,2.262,0,0,1,1.659.69,2.263,2.263,0,0,1,.69,1.659v9.4a2.262,2.262,0,0,1-.69,1.659A2.262,2.262,0,0,1,402.349-825.9Z",
    transform: "translate(-376.955 855.324)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutPopUp);
export default __webpack_public_path__ + "static/media/logout-pop-up.564c23838d2e74fdf4277a6a2d8945a3.svg";
export { ForwardRef as ReactComponent };